import React from "react"
import { createRoot } from "react-dom/client"
import { DocumentRenderer } from "@keystone-6/document-renderer"

export function prepareRangeHoroscopeContent(accordionBodies) {
  accordionBodies.forEach(a => {
    // ถูกเรียกซ้ำได้จากทั้ง turbo:load และ turbo:frame-load — createRoot ซ้ำบนกล่องเดิม
    // ทำให้ React ทิ้ง root เก่าแล้วเนื้อหาหาย จึงเรนเดอร์ใบละครั้งเดียว
    if (a.dataset.contentRendered === "1") { return }
    a.dataset.contentRendered = "1"

    let rootAccordion = createRoot(a)
    let documentContent = JSON.parse(a.dataset.horoscopeContent)
    let documentAdvice = JSON.parse(a.dataset.horoscopeAdvice)
    rootAccordion.render(
      <>
        <DocumentRenderer document={documentContent} />
        {
          documentNotEmpty(documentAdvice) ? (
            <div className="recommend">
              <hr/>
              <h4>{a.dataset.adviceLabel}</h4>
              <DocumentRenderer document={documentAdvice} />
            </div>
          ) : (
            ""
          )
        }
      </>
    )
  })
}

export function prepareMonthlyHoroscopeContent(accordionBodies) {
  accordionBodies.forEach((accordion) => {
    const categoryCards = accordion.querySelectorAll(".category-card")
    categoryCards.forEach((card) => {
      let rootCard = createRoot(card)
      let title = card.dataset.title
      let documentContent = JSON.parse(card.dataset.horoscopeContent)
  
      rootCard.render(
        <>
          {documentNotEmpty(documentContent) ? (
            <div className="mb-4 px-4 py-6 text-new-gray-1 bg-panel-white rounded-lg">
              <div className="mb-2 flex items-center gap-x-2">
                <div className="icon w-9 h-9 bg-neutral-950/10 bg-center bg-no-repeat bg-[length:22px_22px] rounded-full"></div>
                <div className="font-semibold">{title}</div>
              </div>
              <DocumentRenderer document={documentContent} />
            </div>
          ) : (
            ""
          )}
        </>
      )
    })
  })
}

export function prepareMonthlyHoroscopeCategory(card) {
  let root = createRoot(card)
  let documentContent = JSON.parse(card.dataset.horoscopeContent)

  root.render(
    documentNotEmpty(documentContent) ? (
      <DocumentRenderer document={documentContent} />
    ) : (
      <div className="text-label-gray">{card.dataset.emptyLabel}</div>
    )
  )
}

function documentNotEmpty(document) {
  return document.some((doc) =>
    doc.children.some((child) => child.text !== "")
  )
}
